"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBase64FromUrl = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("core-js/modules/es6.promise");

require("regenerator-runtime/runtime");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var getBase64FromUrl =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(url) {
    var data, blob;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url);

          case 2:
            data = _context.sent;
            _context.next = 5;
            return data.blob();

          case 5:
            blob = _context.sent;
            return _context.abrupt("return", new Promise(function (resolve) {
              var reader = new FileReader();
              reader.readAsDataURL(blob);

              reader.onloadend = function () {
                var base64data = reader.result;
                resolve(base64data);
              };
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getBase64FromUrl(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.getBase64FromUrl = getBase64FromUrl;